// src/services/apiService.js
import API from './api'; // or wherever your Axios instance is stored

export const getUserByEmail = (email) => {
  return API.get(`/users/email/${email}`);
};
export const getUserById = (id) => {
  return API.get(`/users/user/${id}`);
};

export const addMemberToTeam = (teamId, userId, role = 'member') => {
  return API.post(`/team/${teamId}/members`, { teamId, userId, role });
};

export const getTeamById = (teamId) => {
  return API.get(`/team/${teamId}`);
};
export const fetchAllTeams = () => {
  return API.get('/team');
};
export const fetchAllUsers = () => {
  return API.get('/api/users');
};

// Add member to team
export const addTeamMember = (teamId, userId, role) => {
  return API.post('/api/teams/members', { teamId, userId, role });
};

export const createTeam = (name, description) => {
  return API.post('/team', { name, description });
};
export const getMyTeams = async () => {
  const res = await API.get('/users/teams/my-teams');
  return res.data.data;
};
// services/action.js
export const removeMemberFromTeam = async (teamId, userId) => {
  return await API.delete(`/team/${teamId}/members/${userId}`);
};
